import React, { useEffect } from 'react';
import './Services.css';

const ServiceSection = ({ title, content, images, reverse }) => (
  <div className={`service-section ${reverse ? 'reverse' : ''}`}>
    <div className="service-content">
      <h2>{title}</h2>
      <p>{content}</p>
    </div>
    <div className="service-images">
      {images.map((img, idx) => (
        <img src={img} alt={`${title} ${idx + 1}`} key={idx} />
      ))}
    </div>
  </div>
);

const Services = () => {
  useEffect(() => {
    const sections = document.querySelectorAll('.service-section');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible'); // class to start animation
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="services-page">
      <h1 className="services-heading">Our Interior Design Services</h1>

      <ServiceSection
        title="Modular Kitchen Interiors"
        content="Transform your cooking space into a smart, stylish, and functional hub. From cabinets to countertops, our modular kitchens are crafted for modern living."
        images={["/images/carousel1.jpeg", "/images/carousel2.jpeg"]}
      />

      <ServiceSection
        title="Luxurious Bedroom Interiors"
        content="Create a serene retreat with luxurious finishes, ambient lighting, and smart storage solutions. Our bedrooms blend comfort and elegance effortlessly."
        images={["/images/carousel1.jpeg", "/images/carousel2.jpeg"]}
        reverse
      />

      <ServiceSection
        title="Elegant Living Rooms"
        content="Design a welcoming living area with premium sofas, statement lighting, and tasteful accents. Our living rooms reflect timeless elegance and comfort."
        images={["/images/carousel1.jpeg", "/images/carousel2.jpeg"]}
      />

      <ServiceSection
        title="Premium Dining Spaces"
        content="Host in style with our premium dining room interiors. From custom dining tables to stunning décor, we make every meal a celebration."
        images={["/images/carousel1.jpeg", "/images/carousel2.jpeg"]}
        reverse
      />

      <ServiceSection
        title="Home Theaters, Recording Rooms, Conference Rooms & Auditoriums"
        content="Acoustic perfection meets aesthetics. Whether it's a cinematic home theater or a high-end conference space, we design with precision and performance in mind."
        images={["/images/carousel1.jpeg", "/images/carousel2.jpeg"]}
      />
    </div>
  );
};

export default Services;
